import React from 'react';
import { CardAddress, CardName, CardWrapper } from './styles';

interface SelectedBpCardProps {
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
}

const SelectedBpCard: React.FC<SelectedBpCardProps> = ({
  name,
  address,
  city,
  state,
  zipCode
}) => {
  if (!name) return null;

  const cityState = city && state ? `${city} - ${state}` : city || state || '';
  const addressParts = [address, cityState, zipCode ? `CEP ${zipCode}` : '']
    .filter(Boolean)
    .join(' | ');

  return (
    <CardWrapper>
      <CardName>{name}</CardName>
      {addressParts && <CardAddress>{addressParts}</CardAddress>}
    </CardWrapper>
  );
};

export default SelectedBpCard;
